import { useState } from 'react';

const ReorderProcessPopupHOC = (Component: any) =>
  function Comp(props: any) {
    const [showReorderProcessPopup, setShowReorderProcessPopup] =
      useState<boolean>(false);

    const processReorderToggleHandler = () => {
      setShowReorderProcessPopup(!showReorderProcessPopup);
    };

    return (
      <Component
        showReorderProcessPopup={showReorderProcessPopup}
        processReorderToggleHandler={processReorderToggleHandler}
        {...props}
      />
    );
  };

export default ReorderProcessPopupHOC;
